const zh = {
  AttendancePivotTable: {
    Student: "学生",
    Visited: "出勤率，%",
    Hours: "课时数",
    Month: "月份",
    Lesson: "课程",
    Date: "日期",
    Duration: "时长",
    Teacher: "教师",
    Days: "天",
    Time: "时间",
    Course: "课程 {{course, string}}",
    GroupSchedule: "{{group, string}} 小组课程安排",
    Total: "课程总计 {{hours, number}} 学时",
    CompletedPeriod: "本周期已完成 {{hours, number}} 学时",
    LeftPeriod: "本周期结束时剩余 {{hours, number}} 学时",
    Typewebinar: "课程类型：线上",
    Typeface2face: "课程类型：线下",
    NotPerformedToPayPeriod: "超额取消 {{hours, number}} 学时",
    TotalInTable: "总计",
    CompletedInTable: "本周期已完成",
    NotPerformedToPayHours: "超额取消：",
    LeftInTable: "本周期结束时剩余",
    MinHours: "学时",
  },
  ReportsAttendance: {
    Title: "出勤",
    SelectGroup: "选择小组",
    AllGroups: "所有小组",
    EmptyGroupAndCompany: "请选择公司或小组以查看报告",
    Download: "下载",
    AllCompanies: "所有公司",
    SelectCompany: "选择公司",
    EmptyLessons: "当前所选筛选条件下没有已完成的课程，因此无法创造勤报告",
    OnlyTeachersLessons: "仅我的课程",
    NoOptions: "没有选项",
    Open: "打开",
    Clear: "清除",
  },
  AttendancePivotReportDownload: {
    Sheet: "透视报告",
  },
  DatePicker: {
    MaskPlaceholder: "dd/mm/yyyy",
    Today: "今天",
    Clear: "清除",
  },
  GroupsAutocompleteFilter: {
    EnterGroupName: "输入小组名称",
    SelectGroup: "选择小组",
  },
  Loading: {
    Error: "加载错误，请尝试刷新页面",
  },
  ModalGroupReport: {
    Teacher: "教师",
    Course: "课程",
    Schedule: "时间表",
    Duration: "时长",
  },
  GroupFilter: {
    SearchStudent: "搜索学生",
    StartDate: "开始日期",
    EndDate: "结束日期",
    Reset: "重置",
  },
  MonthName: {
    "1": "一月",
    "2": "二月",
    "3": "三月",
    "4": "四月",
    "5": "五月",
    "6": "六月",
    "7": "七月",
    "8": "八月",
    "9": "九月",
    "10": "十月",
    "11": "十一月",
    "12": "十二月",
  },
  ShortWeekDay: {
    "0": "周日",
    "1": "周一",
    "2": "周二",
    "3": "周三",
    "4": "周四",
    "5": "周五",
    "6": "周六",
  },
  Progress: {
    totalProgress: "总进度",
    completed: "已完成",
    yourProgress: "您的进度：",
  },
};

export default zh;
